import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "content-box user-information" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between user-information-heading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "user-information-title" }, "Basic Info", -1)
const _hoisted_4 = { class: "user-information-toolbar" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_6 = { class: "me-2" }
const _hoisted_7 = {
  "submit.prevent": "",
  class: "user-information-body mt-4 pt-3"
}
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_AvatarUpload = _resolveComponent("AvatarUpload")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in",
          duration: 150
        }, {
          default: _withCtx(() => [
            (_ctx.editable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_AppButton, {
                      type: "primary-transparent",
                      size: "md",
                      onClick: _ctx.cancelEditHandler
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cancel ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_AppButton, {
                      type: "secondary",
                      disabled: _ctx.valid,
                      size: "md",
                      onClick: _ctx.endEdit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Save ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_AppButton, {
                  key: 1,
                  type: "primary-transparent",
                  size: "md",
                  class: "justify-content-end",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editable = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, { icon: "pen" })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("form", _hoisted_7, [
      _createVNode(_component_AvatarUpload, {
        placeholder: _ctx.userInformation?.image,
        disabled: !_ctx.editable,
        onFileChanged: _ctx.fileUpload
      }, null, 8, ["placeholder", "disabled", "onFileChanged"]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_AppInput, {
            id: "user-id",
            modelValue: _ctx.editData.id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.id) = $event)),
            label: "User Id",
            "input-type": "material",
            disabled: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_AppInput, {
            id: "user-full-name",
            modelValue: _ctx.editData.fullName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData.fullName) = $event)),
            label: "Full name",
            "input-type": "material",
            disabled: !_ctx.editable
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createVNode(_component_AppInputsValidationProvider, { onChangeErrorState: _ctx.changeValidationStatus }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_AppInput, {
                id: "user-email",
                modelValue: _ctx.editData.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editData.email) = $event)),
                label: "Email",
                status: {
                label: _ctx.editData.emailVerified ? 'Verified' : 'Not Verified',
                type: _ctx.editData.emailVerified ? 'success' : 'danger'
              },
                "validation-type": "email",
                "input-type": "material",
                disabled: !_ctx.editable
              }, null, 8, ["modelValue", "status", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_AppInput, {
                id: "user-phone",
                modelValue: _ctx.editData.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editData.phone) = $event)),
                label: "Phone",
                status: {
                label: 'Not Verified',
                type: 'danger'
              },
                "input-type": "material",
                "validation-type": "phone",
                disabled: !_ctx.editable
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["onChangeErrorState"]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.userType === 'user')
            ? (_openBlock(), _createBlock(_component_AppInput, {
                key: 0,
                id: "user-register-date",
                modelValue: _ctx.editData.registerDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editData.registerDate) = $event)),
                label: "Register Date",
                "input-type": "material",
                disabled: true
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.userType === 'user')
            ? (_openBlock(), _createBlock(_component_AppInput, {
                key: 0,
                id: "user-register-ip",
                modelValue: _ctx.editData.registerIP,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editData.registerIP) = $event)),
                label: "Register Ip",
                "input-type": "material",
                disabled: true
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.userType === 'user')
            ? (_openBlock(), _createBlock(_component_AppInput, {
                key: 0,
                id: "user-country-name",
                modelValue: _ctx.editData.registerCountry,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editData.registerCountry) = $event)),
                label: "Register Country",
                "input-type": "material",
                disabled: true
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.userType === 'user')
            ? (_openBlock(), _createBlock(_component_AppInput, {
                key: 0,
                id: "user-device-name",
                modelValue: _ctx.editData.device,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editData.device) = $event)),
                label: "Device",
                "input-type": "material",
                disabled: true
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.userType === 'user')
            ? (_openBlock(), _createBlock(_component_AppInput, {
                key: 0,
                id: "user-server-name",
                modelValue: _ctx.editData.server,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editData.server) = $event)),
                label: "Server",
                "input-type": "material",
                disabled: true
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}